export default "__VITE_ASSET__D2eBv6BF__"